function UserAgreementPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-2xl md:text-3xl font-bold text-center">服务协议</h1>

      <section className="mt-10">
        <h2 className="text-lg font-semibold">首部及导言</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">欢迎您使用我公司的服务！</p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          为使用我公司的服务，您应当阅读并遵守《我公司服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款，以及开通或使用某项服务的单独协议。除非您已阅读并接受本协议所有条款，否则您无权使用我公司提供的服务。您使用我公司的服务即视为您已阅读并同意上述协议的约束。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          如果您未满16周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">甲方：新译信息科技（深圳）有限公司（以下简称：我公司）</p>
        <p className="mt-3 leading-7 text-sm md:text-base">乙方：我公司用户系统在线用户（以下简称：用户）</p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">1、【协议的范围】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          1.1本协议是您与我公司之间关于用户使用我公司相关服务所订立的协议。“我公司”是指新译信息科技（深圳）有限公司及其相关服务可能存在的运营关联单位。“用户”是指使用我公司相关服务的使用人，在本协议中更多地称为“您”。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          1.2本协议项下的服务是指我公司向用户提供的包括但不限于定在线机器翻译、在线辅助翻译、在线翻译插件、智译机器人、智译APP等产品及服务（以下简称“本服务”）。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          1.3本协议内容同时包括《隐私政策》,且您在使用我公司某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何业务规则、单独协议的接受，即视为您对本协议全部的接受。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">2、【帐号与密码安全】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          2.1我公司特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">3、【用户个人信息保护】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          3.1保护用户个人信息是我公司的一项基本原则。我公司将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护规定的内容与上述《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          3.2您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则无法使用本服务或在使用过程中受到限制。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          3.3一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          3.4我公司将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">3.5我公司不会将您的个人信息转移或披露给任何非关联的第三方，除非：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>（1）相关法律法规或法院、政府机关要求</li>
          <li>（2）为完成合并、分立、收购或资产转让而转移；</li>
          <li>（3）为提供您要求的服务所必需。</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          3.6我公司非常重视对未成年人个人信息的保护。若您是16周岁以下的未成年人，在使用我公司的服务前，应事先取得您家长或法定监护人（以下简称&quot;监护人&quot;）的书面同意。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">4、【使用本服务的方式】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          4.1除非您与我公司另有约定，您同意本服务仅为您个人非商业性质的使用。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          4.2您应当通过我公司提供或认可的方式使用本服务。您依本协议条款所取得的权利不可转让。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          4.3您不得使用未经我公司授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">5、【按现状提供服务】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          您理解并同意，我公司的服务是按照现有技术和条件所能达到的现状提供的。我公司会尽最大努力向您提供服务，确保服务的连贯性和安全性；但我公司不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">6、【自备设备】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          6.1您应当理解，您使用我公司的服务需自行准备与相关服务有关的终端设备（如电脑、手机等装置），并承担所需的费用（如电话费、上网费等费用）。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">6.2您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。</p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">7、【收费服务】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          7.1我公司的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          7.2我公司可能根据实际需要对收费服务的收费标准、方式进行修改和变更，我公司也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，我公司将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">7.3我公司的会员及套餐系网络虚拟商品，一经购买后不可退款。</p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">8、【基于软件提供服务】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">若我公司依托“软件”向您提供服务，您还应遵守以下约定：</p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          8.1您在使用本服务的过程中可能需要下载软件，对于这些软件，我公司给予您一项个人的、不可转让及非排他性的许可。您仅可为访问或使用本服务的目的而使用这些软件。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          8.2为了改善用户体验、保证服务的安全性及产品功能的一致性，我公司可能会对软件进行更新。您应该将相关软件更新到最新版本，否则我公司并不保证其能正常使用。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          8.3我公司可能为不同的终端设备开发不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。您可以直接从我公司的网站上获取软件，也可以从得到我公司授权的第三方获取。如果您从未经我公司授权的第三方获取软件或与软件名称相同的安装程序，我公司无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">8.4除非我公司书面许可，您不得从事下列任一行为：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>（1）删除软件及其副本上关于著作权的信息；</li>
          <li>（2）对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；</li>
          <li>（3）对我公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</li>
          <li>
            （4）对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我公司授权的第三方工具/服务接入软件和相关系统；
          </li>
          <li>
            （5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
          </li>
          <li>（6）通过非我公司开发、授权的第三方软件、插件、外挂、系统，登录或使用我公司软件及服务，或制作、发布、传播非我公司开发、授权的第三方软件、插件、外挂、系统。</li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">9、【知识产权声明】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          9.1我公司在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归我公司所有，用户在使用本服务中所产生的内容的知识产权归用户或相关权利人所有。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          9.2除另有特别声明外，我公司提供本服务时所依托软件的著作权、专利权及其他知识产权均归我公司所有。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          9.3我公司在本服务中所使用的 “新译科技”及logo形象等商业标识，其著作权或商标权归我公司所有。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          9.4上述及其他任何本服务包含的内容的知识产权均受到法律保护，未经我公司、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">10、【遵守当地法律监管】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          10.1您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          10.2您应避免因使用本服务而使我公司卷入政治和公共事件，否则我公司有权暂停或终止对您的服务。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">11、【不可抗力及其他免责事由】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          11.1您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我公司将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失我公司在法律允许的范围内免责。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">11.2在法律允许的范围内，我公司对以下情形导致的服务中断或受阻不承担责任：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</li>
          <li>（2）用户或我公司的电脑软件、系统、硬件和通信线路出现故障</li>
          <li>（3）用户操作不当；</li>
          <li>（4）用户通过非我公司授权的方式使用本服务；</li>
          <li>（5）其他我公司无法控制或合理预见的情形。</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          11.3您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，我公司不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：
        </p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>（1）因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</li>
          <li>（2）其他因网络信息或用户行为引起的风险。</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          11.4您理解并同意，本服务并非为某些特定目的而设计，包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，我公司不承担法律责任。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          11.5我公司依据本协议约定获得处理违法违规内容的权利，该权利不构成我公司的义务或承诺，我公司不能保证及时发现违法行为或进行相应处理。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">12、【协议的生效与变更】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">12.1您使用我公司的服务即视为您已阅读本协议并接受本协议的约束。</p>
        <p className="mt-3 leading-7 text-sm md:text-base">12.2我公司有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。</p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          12.3本协议条款变更后，如果您继续使用我公司提供的软件或服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用我公司提供的软件或服务。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">13、【服务的变更、中断、终止】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">13.1我公司可能会对服务内容进行变更，也可能会中断、中止或终止服务。</p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          13.2您理解并同意，我公司有权自主决定经营策略。在我公司发生合并、分立、收购、资产转让时，我公司可向第三方转让本服务下相关资产；我公司也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以我公司通知的为准。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">13.3如发生下列任何一种情形，我公司有权不经通知而中断或终止向您提供的服务：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>（1）根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</li>
          <li>（2）您违反相关法律法规或本协议的约定；</li>
          <li>（3）按照法律规定或主管部门的要求；</li>
          <li>（4）出于安全的原因或其他必要的情形。</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          13.4我公司有权按本协议7.2条的约定进行收费。若您未按时足额付费，我公司有权中断、中止或终止提供服务。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          13.5您有责任自行备份存储在本服务中的数据。如果您的服务被终止，我公司可以从服务器上永久地删除您的数据,但法律法规另有规定的除外。服务终止后，我公司没有义务向您返还数据。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">14、【管辖与法律适用】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          14.1本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">14.2本协议签订地为中华人民共和国北京市通州区北皇木厂北街5号院1号楼17层。</p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          14.3若您和我公司之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地（即北京市通州区北皇木厂北街5号院1号楼17层）人民法院管辖。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          14.4本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          14.5本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">15、【未成年人使用条款】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">15.1若用户未满16周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。</p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          15.2未成年人用户涉世未深，容易被网络虚象迷惑，且好奇心强，遇事缺乏随机应变的处理能力，很容易被别有用心的人利用而又缺乏自我保护能力。因此，未成年人用户在使用本服务时应注意以下事项，提高安全意识，加强自我保护：
        </p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>（1）认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活；</li>
          <li>（2）填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰；</li>
          <li>（3）在监护人或老师的指导下，学习正确使用网络；</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          15.3监护人、学校均应对未成年人使用本服务时多做引导。特别是家长应关心子女的成长，注意与子女的沟通，指导子女上网应该注意的安全问题，防患于未然。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">16、【与我们联系】</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          当你有其他的投诉、建议、未成年人个人信息相关问题时，请通过service02@newtranx.com联系我们，你也可以将你的问题邮寄如下地址：北京市通州区北皇木厂北街5号院1号楼17层（收）
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们将尽快审核所涉问题，并在验证你的用户身份后的三十天内予以回复。
        </p>
      </section>
    </div>
  );
}

export default UserAgreementPage;
